import { Pipe, PipeTransform } from '@angular/core';
import { TranslationService } from '../../../translations';
import { EmailEntity } from '../email-chip-input-form.component';
@Pipe({
    name: 'emailCounter',
    standalone: false
})
export class EmailCounterPipe implements PipeTransform {
    constructor(private TR: TranslationService) {}

    transform(emails: EmailEntity[], maximumEntries: number): string {
        const emailCount = emails.filter(
            (emailEntity) => emailEntity.valid
        ).length;
        return this.TR.keyFormatter(
            'client-admin.users.invite-users.email-counter',
            emailCount,
            maximumEntries
        );
    }
}
